<template>
  <QDialog v-model="showDialog" no-esc-dismiss persistent>
    <QCard style="padding: 0 0 25px 0; width: 700px; max-width: 80vw">
      <QCardSection class="row justify-end q-pb-none">
        <QBtn flat outline round color="grey-9" @click="onCancel" :icon="close" />
      </QCardSection>
      <div class="row justify-center">
        <div class="col-xs-12 col-sm-10 col-md-8" style="padding-top: 40px">
          <h5>Verify Your Identity</h5>
        </div>
        <div class="col-xs-12 col-sm-10 col-md-8">
          <p class="q-mb-lg">We have been unable to capture your identification. Please upload a copy of your drivers licence</p>
          <div class="row q-gutter-x-sm">
            <div class="q-pa-lg cursor-pointer column text-center col bdr-a-grey-5 rounded-borders-lg bdr-dashed">
              <UploadFile :file="frontendFile" name="Frontend" @deleteFile="onDeleteFile" @onUpload="onUpload" />
              <span class="text-weight-bold q-mt-lg"> STEP 1: </span>
              <p class="q-mt-sm">Upload Driver’s Licence Frontend</p>
            </div>
            <div class="q-pa-lg cursor-pointer column text-center col bdr-a-grey-5 rounded-borders-lg bdr-dashed">
              <UploadFile :file="backendFile" name="Backend" @deleteFile="onDeleteFile" @onUpload="onUpload" />
              <span class="text-weight-bold q-mt-lg"> STEP 2: </span>
              <p class="q-mt-sm">Upload Driver’s Licence Backend</p>
            </div>
          </div>
          <QBtn
            color="primary"
            class="full-width"
            label="Save"
            :disable="!frontendFile || !backendFile"
            :loading="savingFiles"
            no-caps
            @click="saveFiles"
            style="margin-top: 25px"
          />
        </div>

        <div class="col-xs-12 col-sm-10 col-md-8">
          <div id="id-scan"></div>
          <br />
          <br />
        </div>
      </div>
    </QCard>
  </QDialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { QBtn, QDialog, QCard, QCardSection, Icons } from 'eclipx.ui';
import UploadFile from './PickFiles.vue';
import { GLOBAL_ERROR } from '../../../components/GlobalError/GlobalError';
import MutationSaveDrivingLicense from '../../../graphql/mutations/MutateSaveDrivingLicense';

export default {
  name: 'UploadDialogBox',
  props: {},
  data() {
    return {
      showDialog: true,
      loadingStarted: false,
      savingFiles: false,
      frontendFile: null,
      backendFile: null
    };
  },
  created() {
    this.close = Icons.evaClose;
    if (this.isUserPrimaryApplicant && this.vehicleApplication?.scoreboard?.primaryApplicant?.idScanData?.fileUrls) {
      const [frontEnd, backEnd] = this.vehicleApplication.scoreboard.primaryApplicant?.idScanData.fileUrls;
      this.frontendFile = frontEnd;
      this.backendFile = backEnd;
    } else if (!this.isUserPrimaryApplicant && this.vehicleApplication?.scoreboard?.secondaryApplicant?.idScanData?.fileUrls) {
      const [frontEnd, backEnd] = this.vehicleApplication?.scoreboard?.secondaryApplicant?.idScanData?.fileUrls;
      this.frontendFile = frontEnd;
      this.backendFile = backEnd;
    }
  },
  computed: {
    ...mapGetters({
      vehicleApplication: 'vehicleApplication/vehicleApplication',
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant'
    })
  },
  methods: {
    ...mapMutations({
      saveDrivingLicense: 'vehicleApplication/saveDrivingLicense'
    }),
    onCancel: async function () {
      this.showDialog = false;
      this.$emit('onClosed');
    },
    onDeleteFile: async function (value) {
      if (value.name === 'Backend') this.backendFile = null;
      else this.frontendFile = null;
    },
    onUpload: async function (value) {
      const name = value.name;
      delete value.name;
      if (name === 'Backend') this.backendFile = value;
      else this.frontendFile = value;
    },
    saveFiles: async function () {
      this.savingFiles = true;
      const applicantType = this.isUserPrimaryApplicant ? 'primaryApplicant' : 'secondaryApplicant';
      const files = [
        {
          fileName: this.frontendFile.fileName,
          mimeType: this.frontendFile.mimeType,
          uuid: this.frontendFile.uuid
        },
        {
          fileName: this.backendFile.fileName,
          mimeType: this.backendFile.mimeType,
          uuid: this.backendFile.uuid
        }
      ];
      return await this.$apollo
        .mutate({
          mutation: MutationSaveDrivingLicense,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            params: files,
            applicantType
          }
        })
        .then(() => {
          this.saveDrivingLicense({ files, applicantType });
          this.savingFiles = false;
          this.showDialog = false;
          this.$emit('onSaved');
        })
        .catch((error) => {
          this.savingFiles = false;
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    }
  },

  components: {
    QBtn,
    QDialog,
    QCard,
    QCardSection,
    UploadFile
  }
};
</script>
